export function iframeLoadedWoocommerceVtex (isCorrect) {
  setTimeout(() => {
    window.parent.postMessage(
      {
        type: 'iframe-mounted',
        origin: 'pinflag-checkout-iframe',
        message: isCorrect
      },
      '*'
    )
  }, 1500)
}

export const iframeLoadedShopify = (isCorrect) => {
  window.parent.postMessage(
    {
      type: 'iframe-loaded',
      origin: 'pinflag-shopify-pinmap-pro',
      message: isCorrect
    },
    '*'
  )
}
